import isMobilePhone from 'validator/lib/isMobilePhone'
import isNumeric from 'validator/lib/isNumeric'

import { TAddBankAccountPayload } from '../apis/mutations/use-post-add-bank-account-mutation'

import { TPayoutInfoParams } from '@/components/private/add-payout-info-form'

export default function validateBankAccountForm(
  values: Partial<TAddBankAccountPayload>,
  type: TPayoutInfoParams,
) {
  const isEWallet = type === 'e-wallet'

  const { provider, accountNumber } = values
  const errors: { [key: string]: string } = {}

  if (!provider) {
    errors.provider = 'Bank field cannot be empty.'
  }

  if (!accountNumber) {
    errors.accountNumber = `${isEWallet ? 'Phone number' : 'Account number'} field cannot be empty.`
  }

  if (accountNumber && !isNumeric(accountNumber, { no_symbols: true }))
    errors.accountNumber = 'Please enter a valid account number.'

  if (accountNumber?.startsWith('-')) {
    errors.accountNumber = `Please enter a valid account number.`
  }

  if (accountNumber && accountNumber.length > 30) {
    errors.accountNumber = `Account number cannot exceed 30 digits.`
  }

  if (isEWallet && accountNumber && !isMobilePhone(accountNumber, 'id-ID'))
    errors.accountNumber = 'Please enter a valid phone number.'

  return errors
}
